module.exports = __webpack_public_path__ + "img/img-3-12.3ee58dcc.webp";